import {uniqueId} from 'lodash'
import placesOfRegistration from '@/constants/placesOfRegistartion'

const routeToCompany = {
  name: 'CompanyContact',
  params: {
    id: 'client.id',
    company: 'id'
  }
}

const routeToClient = {
  name: 'ContactCard',
  params: {
    id: 'client.id'
  }
}

const columns = [
  {
    type: 'checkbox',
    width: '30px'
  },
  {
    type: 'index',
    width: '37px'
  },
  {
    title: 'Company name',
    prop: 'name',
    capitalize: true,
    route: routeToCompany,
    info: 'estCard.estCardNo',
    file: 'estCard.uploadFile',
    width: 'minmax(120px, 1fr)'
  },
  {
    title: 'Nickname',
    prop: 'client.nickName',
    route: routeToClient
  },
  {
    title: 'Formed in',
    prop: 'formedIn',
    type: 'id',
    findIn: placesOfRegistration,
    width: 'minmax(80px, 1fr)',
    route: routeToCompany,
    filters: placesOfRegistration,
    filterId: 'formedIn'
  },
  {
    title: 'Establishment Card Exp Date',
    type: 'date',
    editable: true,
    prop: 'estCard.estCardDate',
    width: 'minmax(115px, 0.6fr)',
    route: routeToCompany
  },
  {
    title: 'Status',
    type: 'status',
    prop: 'estCard.expireStatus',
    route: routeToCompany,
    width: 'minmax(105px, 0.5fr)'
  },
  {
    title: 'Comment',
    type: 'comment',
    prop: 'estCard.comment'
  },
  {
    title: 'Extra',
    filters: true,
    filterType: 'many',
    filterId: 'extra',
    width: '60px'
  },
  {
    type: 'toolbar',
    status: 'estCard.expireStatus',
    comment: 'estCard.comment',
    width: '25px'
  }
]

const prefix = 'contacts_tracking_cards_column_'
const trackingCardsTableColumns = columns.map(item => {
  item.id = uniqueId(prefix)
  return item
})

export {trackingCardsTableColumns}



// WEBPACK FOOTER //
// ./src/constants/TablesOptions/contactsTrackingList/trackingCardsTable.js